function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.9668 18.3058H2.49168C2.0332 18.3058 1.66113 17.9337 1.66113 17.4752V2.52504C1.66113 2.06657 2.03324 1.6945 2.49168 1.6945H9.9668C10.4261 1.6945 10.7973 1.32325 10.7973 0.86395C10.7973 0.404653 10.4261 0.0333252 9.9668 0.0333252H2.49168C1.11793 0.0333252 0 1.15129 0 2.52504V17.4752C0 18.8489 1.11793 19.9669 2.49168 19.9669H9.9668C10.4261 19.9669 10.7973 19.5956 10.7973 19.1363C10.7973 18.677 10.4261 18.3058 9.9668 18.3058Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.7527 9.40867L14.7029 4.42527C14.3773 4.10301 13.8508 4.10719 13.5285 4.43359C13.2062 4.76 13.2095 5.28574 13.5368 5.60801L17.1456 9.16945H7.47532C7.01603 9.16945 6.64478 9.5407 6.64478 10C6.64478 10.4593 7.01603 10.8306 7.47532 10.8306H17.1456L13.5368 14.392C13.2096 14.7143 13.2071 15.24 13.5285 15.5664C13.6913 15.7309 13.9056 15.8139 14.1199 15.8139C14.3308 15.8139 14.5418 15.7342 14.7029 15.5747L19.7527 10.5913C19.9106 10.4352 20.0002 10.2225 20.0002 9.99996C20.0002 9.77746 19.9114 9.56566 19.7527 9.40867Z"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white"
})));

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#A5B1E0",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.6723e079.svg";
export { ForwardRef as ReactComponent };